import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-estate"
}
const _hoisted_2 = { class: "modal-estate-wrapper-logo" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "modal-wrapper-link-with-logo" }
const _hoisted_5 = { class: "modal-estate-wrapper-link" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "modal-estate-wrapper-lotrack-logo" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "modal-content" }
const _hoisted_10 = { class: "wrapper-name" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = {
  key: 0,
  class: "error"
}
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = {
  key: 0,
  class: "error"
}
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = {
  key: 0,
  class: "error"
}
const _hoisted_17 = { class: "form-group form-group--password" }
const _hoisted_18 = {
  key: 0,
  class: "error"
}
const _hoisted_19 = { class: "form-group progress-bar" }
const _hoisted_20 = { class: "form-group" }
const _hoisted_21 = { class: "agree" }
const _hoisted_22 = { class: "form-group" }
const _hoisted_23 = {
  key: 0,
  class: "error"
}
const _hoisted_24 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock($setup["Modal"], {
    "is-open": $props.isOpen,
    onClose: $setup.close,
    classes: "registration-modal height-limited",
    "transition-name": _ctx.transitionName
  }, {
    content: _withCtx(() => [
      _createElementVNode("form", {
        class: "login-form login-form-limited scroll-wrapper",
        onSubmit: _withModifiers($setup.submitForm, ["prevent"])
      }, [
        ($props.estate)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("img", {
                  src: $props.estate.imgPath
                }, null, 8, _hoisted_3)
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("img", {
                    src: require(`@/assets/icons/icon-link.svg`)
                  }, null, 8, _hoisted_6)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("img", {
                    src: require(`@/assets/icons/logo-black.svg`)
                  }, null, 8, _hoisted_8)
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _cache[16] || (_cache[16] = _createElementVNode("div", { class: "modal-title" }, "Create a free LotTrackr account", -1)),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("label", null, [
                _cache[7] || (_cache[7] = _createElementVNode("span", { class: "label" }, "First Name", -1)),
                _withDirectives(_createElementVNode("input", {
                  class: _normalizeClass(["input-large", { 'input--error': $setup.v$.firstName.$error }]),
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.form.firstName) = $event)),
                  placeholder: "First Name"
                }, null, 2), [
                  [_vModelText, $setup.form.firstName]
                ])
              ]),
              ($setup.v$.firstName.$error)
                ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString($setup.v$.firstName.$errors[0].$message), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("label", null, [
                _cache[8] || (_cache[8] = _createElementVNode("span", { class: "label" }, "Last Name", -1)),
                _withDirectives(_createElementVNode("input", {
                  class: _normalizeClass(["input-large", { 'input--error': $setup.v$.lastName.$error }]),
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.form.lastName) = $event)),
                  placeholder: "Last Name"
                }, null, 2), [
                  [_vModelText, $setup.form.lastName]
                ])
              ]),
              ($setup.v$.lastName.$error)
                ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString($setup.v$.lastName.$errors[0].$message), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("label", null, [
              _cache[9] || (_cache[9] = _createElementVNode("span", { class: "label" }, "Email", -1)),
              _withDirectives(_createElementVNode("input", {
                class: _normalizeClass(["input-large", { 'input--error': $setup.v$.email.$error }]),
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.form.email) = $event)),
                placeholder: "Type your email"
              }, null, 2), [
                [_vModelText, $setup.form.email]
              ])
            ]),
            ($setup.v$.email.$error)
              ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString($setup.v$.email.$errors[0].$message), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("label", null, [
              _cache[10] || (_cache[10] = _createElementVNode("span", { class: "label" }, "Password", -1)),
              _createVNode($setup["InputPassword"], {
                modelValue: $setup.form.password,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.form.password) = $event)),
                "input-classes": ['input-large', { 'input--error': $setup.v$.password.$error }],
                placeholder: "Type your password"
              }, null, 8, ["modelValue", "input-classes"]),
              ($setup.v$.password.$error)
                ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString($setup.v$.password.$errors[0].$message), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createVNode($setup["PasswordProgress"], {
              password: $setup.form.password
            }, null, 8, ["password"])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createVNode($setup["CheckboxInput"], {
                class: "agree-checkbox",
                modelValue: $setup.isAgree,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.isAgree) = $event))
              }, null, 8, ["modelValue"]),
              _createElementVNode("span", {
                class: "unselectable agree-label-wrapper",
                onClick: $setup.onAgree
              }, [
                _cache[13] || (_cache[13] = _createElementVNode("span", { class: "agree__label" }, "I agree to the LotTrackr ", -1)),
                _createVNode(_component_router_link, {
                  class: "agree__label--highlighted",
                  to: { name: 'CustomerTerms' },
                  target: "_blank",
                  onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
                }, {
                  default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                    _createTextVNode("Terms of Service ", -1)
                  ]))]),
                  _: 1
                }),
                _cache[14] || (_cache[14] = _createElementVNode("span", { class: "agree__label" }, "and ", -1)),
                _createVNode(_component_router_link, {
                  class: "agree__label--highlighted",
                  to: { name: 'PrivacyPolicy' },
                  target: "_blank",
                  onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"]))
                }, {
                  default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                    _createTextVNode("Privacy Policy.", -1)
                  ]))]),
                  _: 1
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            ($setup.props.message)
              ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString($setup.props.message), 1))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              class: "button button--agree primary w-100",
              disabled: !$setup.isAgree
            }, "Agree & Complete Sign Up", 8, _hoisted_24)
          ]),
          _createElementVNode("div", null, [
            _cache[15] || (_cache[15] = _createElementVNode("span", { class: "member" }, "Already have an account? ", -1)),
            _createElementVNode("span", {
              class: "login",
              onClick: $setup.login
            }, "Log in")
          ])
        ])
      ], 32)
    ]),
    _: 1
  }, 8, ["is-open", "transition-name"]))
}